import {animate} from "@straylightagency/animate";

export async function scrollTo(to) {
    return animate({
        from: window.scrollY,
        to,
        duration: 500,
        update: value => window.scrollTo(0, value)
    });
}